import { Tooltip } from "~/components/Tooltip";

// // // //

export function TooltipPassthru(props: {
    children: React.ReactNode;
    tooltipContent: string | null;
}) {
    const { children, tooltipContent } = props;

    if (!tooltipContent) {
        return <>{children}</>;
    }

    return (
        <Tooltip
            placement="top-start"
            tooltipContent={
                <div className="w-max px-3">
                    <p className="py-1.5 text-xs text-center">
                        {tooltipContent}
                    </p>
                </div>
            }
        >
            {({ setTriggerRef }) => <span ref={setTriggerRef}>{children}</span>}
        </Tooltip>
    );
}
